// @core/api/endpoints/team/create_team_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTeamRoleRequest,
  TeamRoleResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Create custom team role
 * Creates a new custom role for the team with specific permissions. Team owners can define role capabilities.
 */
export async function CreateTeamRole(
  team_id: string,
  data: CreateTeamRoleRequest,
  options?: RequestOptions
): Promise<TeamRoleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/roles`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<TeamRoleResponse>(requestPath, data, requestOptions);
}
